<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :showBg="showBg"
          @showBg="showBg = true"
          @closeBg="showBg = false"
          :model="models"/>
      </div>
    </div>
    <div class="choose-area-background" v-if="showBg" @click="showBg = false"></div>
  </div>
</template>

<script>
// import gql from "graphql-tag";
import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import formEdit from './add'
import moment from "moment-timezone";
// import md5 from 'js-md5'
export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Tạo Phiếu Nhập",
      mode: 'add',
      showBg: false,
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0,
      page_transaction:null,
      id:null
    }
  },
  watch: {
    "showBg"() {
      document.body.style.overflow = this?.showBg ? 'hidden' : 'auto';
    }
  },
  async mounted () {
    // console.log("this.$route.name:",this.$route.query.page_transaction);
    this.mode = this.$route.name === 'viewImport' ? 'view' : this.mode;
    this.title = this.mode === 'view' ? 'Chi tiết phiếu nhập' : this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_USER);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-import' });
    },
    convertPhone(numberPhone) {
      var phone = numberPhone
      if (numberPhone[0] === '0') {
        phone = phone.substring(1);
      }
      phone = phone.replace(' ', '')
      phone = '+84' + phone
      return phone
    },
    async getTotalCount() {
      var now = new Date();
      var gqLQueryCount = DataServices.countData("record");
      var countRes = await this.$apollo.mutate({
        mutation: gqLQueryCount,
        variables: {
          where_key: {
            type: {_eq: 1},
            created_at: {_gte: moment(now).tz("Asia/Ho_Chi_Minh").startOf('day').toDate(), _lte:moment(now).tz("Asia/Ho_Chi_Minh").endOf('day').toDate()}
          }
        }
      });
      var total = countRes.data['record_aggregate']['aggregate']['count'] + 1;
      return total >= 10 ? total : `0${total}`;
    },
    async saveData(params) {
      if (params !== undefined && Object.entries(params).length > 0) {
        var objects = {
          // code: this.code.toUpperCase(),
          // detail: this.detail,
          number_import: params.number_import,
          farm_id: params.farm?.id,
          kind_id: params.kind?.id,
          type: params.type,
          kind_type_id: params.kind_type,
          date_obj: moment(params.date_obj).tz("Asia/Ho_Chi_Minh").toDate(),
          weight: params.weight,
          created_by: this.$store.getters.user
        }
        var detail = params.detail;
        var images = params.images;
        var videos = params.videos;
        var that = this;
        if (this.mode === 'add') {
          var total = await this.getTotalCount();
          var now = new Date();
          var dateImport = `${now.getDate()}${(now.getMonth()+1)}${now.getFullYear()}`;
          objects.code = `NC${dateImport}-${total}`;
            await this.$apollo.mutate({
              mutation: DataServices.insertData('record'),
              variables: {
                objects: objects
              }
            }).then(async (res) => {
              if (res.data[Object.keys(res.data)].affected_rows) {
                var returning = res.data[Object.keys(res.data)].returning[0];
                var listBox = [];
                // var kindInBox = [];
                for (let i=0; i < detail.length; i++) {
                  if (detail[i]?.value && detail[i].value.length > 0) {
                    detail[i].value.map(async m => {
                      // console.log("detaildetaildetail", m);
                      listBox.push({
                        number: m.value,
                        obj_box_id: m.id,
                        unit_id: detail[i].id,
                        record_id: returning.id,
                        type: params.type
                      })
                      var boxObj = {
                        total: m.total,
                        kind_id: params.kind?.id,
                        weight: params.weight,
                        active: true,
                        date_growth: moment(new Date()).tz("Asia/Ho_Chi_Minh").toDate()
                      }
                      await this.$apollo.mutate({
                      mutation: DataServices.updateData('obj_box'),
                      variables: {
                      'data_update': boxObj,
                        'where_key': {
                          'id': {'_eq': m.id}
                        }
                      }
                      }).catch(async error => {
                        console.log('error', error);
                        that.$toast.add({
                          severity: 'error',
                          summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                          detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                          life: 3000
                        });
                      });
                    })
                  }
                }
                setTimeout(async () => {
                  let variables__ = {
                      objects: listBox
                  };
                  await this.$apollo.mutate({
                      mutation: DataServices.insertData('record_detail'),
                      variables: variables__
                  }).catch(async error => {
                    console.log('error', error);
                    that.$toast.add({
                      severity: 'error',
                      summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                      detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                      life: 3000
                    });
                  });

                  // let variables_ = {
                  //     objects: kindInBox
                  // };
                  // await this.$apollo.mutate({
                  //     mutation: DataServices.insertData('kind_in_box'),
                  //     variables: variables_
                  // }).catch(async error => {
                  //   console.log('error', error);
                  //   that.$toast.add({
                  //     severity: 'error',
                  //     summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  //     detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  //     life: 3000
                  //   });
                  // });
                  if (videos && videos.length > 0){
                    var type_video = videos[0].type;
                    if (type_video != 'old_edit') {
                      await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.IMPORT, videos).then((resImage) => {
                        // console.log("resresres=====:", resImage);
                        if (resImage) {
                          var objectImage = resImage[0];//lấy 1 tấm hình
                          this.$CoreService.updateDataImage(this.$constants.TYPE_VIDEO.IMPORT, returning.id, objectImage).then(() => {
                              // this.redirectEdit();
                          }).catch(async error => {
                              console.log('error', error);
                              this.$toast.add({
                                  severity: 'error',
                                  summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                                  detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                                  life: 3000
                              });
                              this.$commonFuction.is_loading(false);
                          });
                        }
                      });
                    }
                  }
                  var upImg = 0;
                  if (images && images.length > 0){
                    for(let img = 0; img < images.length; img++) {
                      var type_image = images[img].type;
                      if (type_image != 'old_edit') {
                        await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.IMPORT, [images[img]]).then((resImage) => {
                          // console.log("resresres=====:", resImage);
                          if (resImage) {
                            var objectImage = resImage[0];//lấy 1 tấm hình
                            this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.IMPORT, returning.id, objectImage).then(() => {
                              upImg++;
                              if (upImg == images.length) {
                                this.redirectEdit();
                              }
                            }).catch(async error => {
                                console.log('error', error);
                                this.$toast.add({
                                    severity: 'error',
                                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                                    life: 3000
                                });
                                this.$commonFuction.is_loading(false);
                            });
                          }
                        });
                      }
                    }
                  }else {
                    this.redirectEdit();
                  }
                }, 500);
              } else {
                that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                  life: 3000
                });
                this.$commonFuction.is_loading(false);
              }
            }).catch(async error => {
              console.log('error', error);
              that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
              });
              this.$commonFuction.is_loading(false);
              // this.summitEvent = false;
            });
        }
      }
    },
    async uploadImagesOld(userID) {
      var s3client = Config.s3Client('user')
      if (this.images && userID) {
        //xoá avatar
        if (this.oldImages.length > 0) await this.deleteAvatar(s3client);

        this.$store.commit('setLoading', true);
        var objects = null;
        for (let index = 0; index < this.images.length; index++) {
          const img = this.images[index];
          let file = img.source
          if (file !== '' && img.file !== '') {
            let fileName = img.name;
            let random = Math.random().toString().slice(2);
            fileName = `${random}_${fileName}`
            await s3client.uploadFile(file, fileName).then((data) => {
              objects = data.location;
            });
          }
        }
        // console.log(objects);
        if (objects !== null) {
          this.$apollo.mutate({
            mutation: DataServices.updateData('users'),
            variables: {
              'data_update': {
                'avatar': objects
              },
              'where_key': {
                'id': {'_eq': userID}
              }
            }
          }).then(() => {
            // console.log('UPDATE AVATAR THANH CONG')
          }).catch((error) => {
            console.error('ERROR: ', error)
          })
        }
      }
    },
    async redirectEdit() {
      var that = this;
      var router_back = {path: '/admin/list-import'};
      that.$commonFuction.is_loading(false);
      if(that.mode == 'add'){
        that.$router.push(router_back);
      }else{
        if (!that.$commonFuction.isEmpty(router_back)){
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async deleteAvatar(s3client) {
      for (let i = 0; i < this.oldImages.length; i++) {
        let fileName = this.oldImages[i].name
        await s3client.deleteFile(fileName)
      }
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('import'),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var importImage = await this.$CoreService.getFile(this.$constants.TYPE_IMAGE.IMPORT,this.models.id,0);
        if (importImage.listData.length > 0){
          this.models.list_files = importImage.listData;
        }
        var importVideo = await this.$CoreService.getFile(this.$constants.TYPE_VIDEO.IMPORT,this.models.id,0);
        if (importVideo.listData.length > 0){
          this.models.list_files_video = importVideo.listData;
        }
      }
      this.componentKey++;
    },

  },
  // apollo: {
  //   categories: {
  //     query() {
  //       return DataServices.getList('category', {"fields" : "id name"});
  //     },
  //     update(data) {
  //       return data[Object.keys(data)];
  //     },
  //     fetchPolicy: "network-only"
  //   },
  //   users: {
  //     query() {
  //       return DataServices.getList('users', {"fields" : "id fullname phone"});
  //     },
  //     update(data) {
  //       return data[Object.keys(data)];
  //     },
  //     fetchPolicy: "network-only"
  //   }
  // }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 5px; padding: 0;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>
<style>
.list-group-v {
  /* display: -webkit-box;
   display: -ms-flexbox;*/
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  /*-ms-flex-direction: column;*/
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.list-group-item-v:first-child {
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}
.list-group-item-v {
  position: relative;
  display: block;
  padding: .75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125) ;
  height: 50px;
}
.box-check-box{
  position: relative;
}
.box-check-box label{
  position: absolute;
  left: 0px;
  top: 2px;
}
.box-check-box .check-box-day{
  position: absolute;
  right: 0px;
  top: 2px;
}
</style>